export const getTaxes = (state) => state.taxes